(($) => {
  const $body = $('body');

  const $offCanvasLeft = $('.off-canvas-left');
  const $offCanvasRight = $('.off-canvas-right');

  const $offCanvasLeftButton = $('.off-canvas-left-button');
  const $offCanvasRightButton = $('.off-canvas-right-button');

  const $offCanvasCloseButton = $('.off-canvas-close-button');

  const openOffCanvas = ($offCanvas, $offCanvasButton, closeOffCanvasWrapper) => {
    $offCanvas.addClass('active');
    $offCanvasButton.addClass('active');

    $body.addClass('modal-open');

    $offCanvasButton.unbind('click');
    $offCanvasButton.click(closeOffCanvasWrapper);
  };

  const closeOffCanvas = ($offCanvas, $offCanvasButton, openOffCanvasWrapper) => {
    $offCanvas.removeClass('active');
    $offCanvasButton.removeClass('active');

    $body.removeClass('modal-open');

    $offCanvasButton.unbind('click');
    $offCanvasButton.click(openOffCanvasWrapper);
  };

  const showCloseButton = () => {
    $offCanvasCloseButton.removeClass('display-none');

    setTimeout(() => {
      $offCanvasCloseButton.addClass('active');
    }, 50);
  };

  const hideCloseButton = () => {
    $offCanvasCloseButton.removeClass('active');

    setTimeout(() => {
      $offCanvasCloseButton.addClass('display-none');
    }, 500);
  };

  const openOffCanvasWrapper = (closeOffCanvasFunction, openOffCanvasFunction) => {
    closeOffCanvasFunction();
    openOffCanvasFunction();
    showCloseButton();
  };

  const closeOffCanvasWrapper = () => {
    closeOffCanvasLeft();
    closeOffCanvasRight();
    hideCloseButton();
  };

  const openOffCanvasLeft = () => openOffCanvas($offCanvasLeft, $offCanvasLeftButton, closeOffCanvasWrapper);

  const openOffCanvasLeftWrapper = () => openOffCanvasWrapper(closeOffCanvasRight, openOffCanvasLeft);

  const closeOffCanvasLeft = () => closeOffCanvas($offCanvasLeft, $offCanvasLeftButton, openOffCanvasLeftWrapper);

  const openOffCanvasRight = () => openOffCanvas($offCanvasRight, $offCanvasRightButton, closeOffCanvasWrapper);

  const openOffCanvasRightWrapper = () => openOffCanvasWrapper(closeOffCanvasLeft, openOffCanvasRight);

  const closeOffCanvasRight = () => closeOffCanvas($offCanvasRight, $offCanvasRightButton, openOffCanvasRightWrapper);

  const closeOffCanvasAll = () => {
    closeOffCanvasLeft();
    closeOffCanvasRight();
    hideCloseButton();
  };

  $($offCanvasLeftButton).click(openOffCanvasLeftWrapper);
  $($offCanvasRightButton).click(openOffCanvasRightWrapper);
  $($offCanvasCloseButton).click(closeOffCanvasAll);

  const scrollToTop = () => {
    $('html, body').animate({ scrollTop: 0, }, 600);

    return false;
  };

  const scrollTo = (e) => {
    e.preventDefault();
    closeOffCanvasAll();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top,
    }, 500);
  };

  // Scroll to
  $('.scrollToTop').click(scrollToTop);
  $('a[href^="#"].scrollTo').click(scrollTo);
  //$('.menu-item a[href^="#"]').click(scrollTo);

  $('.menu-item a').click(() => {
    closeOffCanvasAll();
  });
  /* eslint-disable-next-line no-undef */
})(jQuery);
